import { createAsyncThunk } from '@reduxjs/toolkit';
import { getCurrentUserPermissions } from 'scenes/Permissions/services/getCurrentUserPermissions.service';

export const loadAllCurrentUserPermissions = createAsyncThunk(
  'permissions/loadAllCurrentUserPermissions',
  async (_) => {
    const {
      projectPermissions,
      businessPermissions,
      adminPermissions,
      isSystemAdmin,
      mayUseNerobotti,
      nerobotti,
    } = await getCurrentUserPermissions();

    return {
      projectPermissions,
      businessPermissions,
      adminPermissions,
      isSystemAdmin,
      mayUseNerobotti,
      // The state the assistant's panel opens in — unlimited, a free-tier
      // percentage, used up, or "pick an employer". Read by nerobottiSlice,
      // not by the permissions slice; it rides this payload because the
      // API answers it beside mayUseNerobotti from the same door.
      nerobotti,
    };
  }
);
